/**
 * safe() helper — wraps async API calls so a missing method doesn't crash
 * the whole dashboard. Errors are REPORTED to Sentry (not silently swallowed).
 *
 * Usage:
 *   safe(() => api.auditStats(), "cockpits.auditStats")
 *   safe(() => api.health(), "cockpits.health")
 */
import { captureError } from "./sentry";

export async function safe<T>(
  fn: () => Promise<T>,
  context?: string,
  fallback: T = {} as T
): Promise<T> {
  try {
    return await fn();
  } catch (e: any) {
    // Report to Sentry with context
    captureError(e, { context: context || "safe()", type: "api_call_failed" });
    return fallback;
  }
}